










































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ICustomerAddress, TFormValidator } from "@/interfaces";
import {
  FIRST_NAME_VALIDATORS,
  LAST_NAME_VALIDATORS,
  EMAIL_VALIDATORS,
  PHONE_VALIDATORS,
  ADDRESS1_RULES,
	COMPANY_NAME_VALIDATORS,
	CUSTOMER_NAME_VALIDATORS
} from "@/validators";

@Component({
})
export default class RimRepairCustomerFormComponent extends Vue {
  @Prop({ required: true }) customerAddress!: ICustomerAddress;
	@Prop({ required: true }) type!: string;
	@Prop({ default: false }) isBilling!: boolean;
	
  public addressRules = ADDRESS1_RULES;
  public customerNameRules = CUSTOMER_NAME_VALIDATORS;
  public companyNameRules = COMPANY_NAME_VALIDATORS;
  public firstNameRules = FIRST_NAME_VALIDATORS;
  public lastNameRules = LAST_NAME_VALIDATORS;
  public emailRules = EMAIL_VALIDATORS;
  public phoneRules = PHONE_VALIDATORS;

  // get copyText() {
  //   return this.type === 'Billing' ? 'Copy from shipping' : 'Copy from billing';
  // }

  // copy(): void {
  //   this.$emit('copy', this.type);
  // }
}

